module.exports = __webpack_public_path__ + "static/media/gal5.dcc969ed.jpeg";